import { useMutation as RQUseMutation } from '@tanstack/react-query';
import * as deepmerge from 'deepmerge';
import isNil from 'lodash-es/isNil';
import { useMemo } from 'react';
import { useGlobalConfig } from './GlobalClientConfigProvider';
import { deleteQueriesContainingPattern, invalidateQueries, invalidateQueriesContainingPattern } from './queryClient';
/**
 * React hook for making a mutation
 */
const useMutation = (requester, config) => {
    const globalConfig = useGlobalConfig();
    /** This is to avoid overriding global error handling (but can be used for other fields of the config) */
    const deepMergedConfig = deepmerge.all([
        requester.cacheConfig || {},
        config || {}
    ]);
    const state = RQUseMutation({
        mutationFn: requester.request,
        ...globalConfig,
        ...deepMergedConfig,
        onError: (e, variables, snapshotValue) => {
            globalConfig?.onError?.(e, variables, snapshotValue);
            deepMergedConfig?.onError?.(e, variables, snapshotValue);
        },
        onSuccess: (data, variables, snap) => {
            invalidateQueries(config?.keysToInvalidate);
            invalidateQueries(requester.keysToInvalidate);
            if (!isNil(requester.patternToDelete)) {
                deleteQueriesContainingPattern(requester.patternToDelete);
            }
            if (!isNil(requester.patternToInvalidate)) {
                invalidateQueriesContainingPattern(requester.patternToInvalidate);
            }
            if (config?.onSuccess)
                config.onSuccess(data, variables, snap);
        }
    });
    const { mutateAsync } = state;
    const mutater = useMemo(() => (vars, opts) => mutateAsync(vars, opts), [mutateAsync]);
    return [mutater, state];
};
export default useMutation;
